import { defineMessages } from 'react-intl';

export const scope = 'app.components.Communication.ComposePanel';

// The three token-tier messages are the copy source for the live per-field issue
// text, filled per surface via buildFieldTokenMessages.
export const messages = defineMessages({
  emailSectionHeading: { id: `${scope}.emailSectionHeading`, defaultMessage: 'Email message' },
  smsSectionHeading: { id: `${scope}.smsSectionHeading`, defaultMessage: 'SMS message' },
  // {noun} is filled by the pluralize helper (message/messages) so the count word
  // agrees without ICU plural syntax; delivery is asynchronous post-enqueue.
  queuedSuccessHeadline: {
    id: `${scope}.queuedSuccessHeadline`,
    defaultMessage: 'Queued {count} {noun} — delivering in the background'
  },
  queuedSuccessPointer: {
    id: `${scope}.queuedSuccessPointer`,
    defaultMessage: 'Track delivery progress on the History tab.'
  },
  tokenIssueUnknown: {
    id: `${scope}.tokenIssueUnknown`,
    defaultMessage: 'Unknown variables: {tokens} — add {article} {sessionTerm} context or remove them'
  },
  tokenIssueSpelling: {
    id: `${scope}.tokenIssueSpelling`,
    defaultMessage: 'Unknown variables: {tokens} — please check spelling'
  },
  tokenIssueSplit: {
    id: `${scope}.tokenIssueSplit`,
    defaultMessage: 'Formatting split these variables: {tokens} — delete and re-insert them'
  },
  tokenIssueNeedsDefault: {
    id: `${scope}.tokenIssueNeedsDefault`,
    defaultMessage: '{tokens} can be blank for some recipients — add a default after a | inside the braces, e.g. {player.jerseyNumber|TBD}, or {player.jerseyNumber|} to allow a blank'
  }
});
